export const AUTH = 'auth'

export const ENDPOINTS = {
  LOGIN: `/${AUTH}/login`,
  LOGOUT: `/${AUTH}/logout`,
  RESET_PASSWORD: `/${AUTH}/reset-password`,
  FORGOT_PASSWORD: `/${AUTH}/forgot-password`,
  UPDATE_PASSWORD: `/${AUTH}/update-password`,
  REFRESH_TOKEN: `/${AUTH}/refresh-token`,
  RESEND_TOKEN: `/${AUTH}/resend-token`,
  VALIDATE_EMAIL: `/${AUTH}/validate-email`,
  RESEND_VERIFICATION: `/${AUTH}/resend-verification`,
  ME: `/${AUTH}/me`,
  CHECK_SETUP_TOKEN: `/${AUTH}/check-setup-token`,
}
